export enum SubscriptionType {
  FREE = 'free',
  PREMIUM_MONTHLY = 'premium_monthly',
  PREMIUM_YEARLY = 'premium_yearly',
  DR_VICTORIA = 'dr_victoria',
  GUEST = 'guest'
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  PENDING = 'pending'
}

export interface SubscriptionLimits {
  maxPets: number;
  maxLogs: number;
  maxAiChats: number;
  maxReminders: number;
}

export interface SubscriptionUsage {
  currentPets: number;
  currentLogs: number;
  currentAiChats: number;
  currentReminders: number;
  lastResetDate: Date;
}

export interface Subscription {
  id: string;
  userId: string;
  type: SubscriptionType;
  status: SubscriptionStatus;
  startDate: Date;
  endDate?: Date; // null pour lifetime
  cancelAtPeriodEnd?: boolean;
  cancelAt?: Date;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  limits: SubscriptionLimits;
  usage: SubscriptionUsage;
  createdAt: Date;
  updatedAt: Date;
}

export interface SubscriptionPlan {
  type: SubscriptionType;
  name: string;
  description: string;
  price: number;
  currency: string;
  interval: 'month' | 'year' | 'lifetime';
  features: string[];
  limits: SubscriptionLimits;
  stripePriceId?: string;
}
